import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-refresh"
export default class extends Controller {
  static values = { 
    interval: Number,
    url: String 
  }
  
  connect() {
    this.startPolling()
  }
  
  disconnect() {
    this.stopPolling()
  }
  
  startPolling() {
    if (this.hasIntervalValue && this.hasUrlValue) {
      this.timer = setInterval(() => {
        this.refreshContent()
      }, this.intervalValue)
    }
  }
  
  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
  
  refreshContent() {
    fetch(this.urlValue, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => response.text())
    .then(html => {
      if (html.trim()) {
        Turbo.renderStreamMessage(html)
      }
    })
    .catch(error => {
      console.error('Auto-refresh error:', error)
    })
  }
  
  // Method to pause/resume polling (useful when user is actively interacting)
  pause() {
    this.stopPolling()
  }
  
  resume() {
    this.startPolling()
  }
}
